import React, { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Sampletext = () => {
  const [descriptions, setDescriptions] = useState([]);

  const fetchDescriptions = async () => {
    try {
      const res = await fetch(getApiUrl("advertisementdescription-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const result = await res.json();
      if (result.success) {
        setDescriptions(result.data || []);
      }
    } catch (err) {
      toast.error("Failed to load advertisements");
    }
  };

  useEffect(() => {
    fetchDescriptions();
  }, []);

  return (
    <div className="add-container">
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={50}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 3000,        // 3 seconds - "little speed"
          disableOnInteraction: false,  // Continues after clicks
          pauseOnMouseEnter: true,     // Pause on hover (optional)
        }}
        speed={1000}         // 1 second smooth transition
        navigation={true}
        grabCursor={true}
        // NO manual start() calls - let Swiper handle it
      >
        {descriptions.length > 0 ? (
          descriptions.map((desc, index) => (
            <SwiperSlide key={`desc-${index}`}>
              <div className="ad-slide">
                <h4>{desc}</h4>
              </div>
            </SwiperSlide>
          ))
        ) : (
         
          Array(3).fill().map((_, index) => (
            <SwiperSlide key={`loading-${index}`}>
              <div className="ad-slide">
                <p>Loading ads...</p>
              </div>
            </SwiperSlide>
          ))
        )}
      </Swiper>
      <ToastContainer />
    </div>
  );
};

export default Sampletext;
